export default __webpack_public_path__ + "newpartner.mp3";